"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Detail3 = exports.Detail2 = exports.Detail1 = exports.P = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("../../constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const base = (0, _styledComponents.css)`
	letter-spacing: 0;
	margin: 0;
	line-height: 1.428;
`;
const P = _styledComponents.default.p`
	font-family: ${_constants.fonts.book};
	font-size: ${_constants.fontSizes.body};
	${base}
`;
exports.P = P;
const Detail1 = _styledComponents.default.p`
	font-family: ${_constants.fonts.book};
	font-size: ${_constants.fontSizes.detail1};
	${base}
`;
exports.Detail1 = Detail1;
const Detail2 = _styledComponents.default.p`
	font-family: ${_constants.fonts.book};
	font-size: ${_constants.fontSizes.detail2};
	margin: 0;
	line-height: 1.428;
	letter-spacing: 0.2px;
`;
exports.Detail2 = Detail2;
const Detail3 = (0, _styledComponents.default)(Detail2)`
	font-family: ${_constants.fonts.bold};
`;
exports.Detail3 = Detail3;